import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { withApp, scrollTop } from 'helpers'
import { Redirect } from 'react-router-dom'
import { Animation, Page, PageIntro } from 'components/library'
import { Chapters } from 'content/chapters'
import { bindActionCreators } from 'redux'
import * as accountActions from 'store/actions/accountActions'
import { translate } from 'translations'

class ChapterIntroView extends React.Component {
  componentDidMount() {
    scrollTop()

    this.setTheme()
    this.props.app.setBackground(this.chapter.poster, this.chapter.posterStyle)
    this.props.app.setLocation({ label: 'intro', id: this.chapter.id })
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.chapter !== this.props.match.params.chapter) {
      this.setTheme()
      scrollTop()
      this.props.app.setBackground(this.chapter.poster, this.chapter.posterStyle)
    }
  }

  setTheme() {
    const nav = this.props.navigation.find(item => item.chapterId === this.chapter.id)
    this.props.app.triggerTheme(nav.theme || 'default')
  }

  get chapter() {
    return this.props.chapters.find(item => item.slug === this.props.match.params.chapter) || {}
  }

  get progress() {
    const nav = this.props.navigation.find(item => item.chapterId === this.chapter.id)
    return this.props.progress.find(item => item.id === nav.id)
  }

  handleHome = e => {
    this.props.history.push(Routes.to('home'))
  }

  handleSubmit = e => {
    // const nav = this.props.navigation.find(item => item.chapterId === this.chapter.id)
    // this.props.accountActions.updateProgress(nav.id, 1)

    this.props.history.push(Routes.to('aspect', { chapter: this.chapter.slug, aspect: 1 }))
  }

  render() {
    if(this.chapter.id) {
      if(this.chapter.intro) {
        return (
          <Page name="Intro" theme={this.props.app.theme}>
            <Animation name="slideInDown" delay={100}>
              <PageIntro
                title={this.chapter.title}
                description={this.chapter.description}
                progress={this.progress}
                chapter={this.chapter}
                continueButtonLabel={translate('card.start')}
                handleHome={this.handleHome}
                handleContinue={this.handleSubmit}>
                <CurrentChapterIntro chapter={this.chapter} />
              </PageIntro>
            </Animation>
          </Page>
        )
      } else {
        return <Redirect to={Routes.to('aspect', { chapter: this.chapter.slug, aspect: 1 })} />
      }
    }

    else {
      return <Redirect to={Routes.to('home')} />
    }
  }
}

const CurrentChapterIntro = props => {
  const id = props.chapter.id < 10 ? `0${props.chapter.id}` : props.chapter.id
  const Chapter = Chapters[`Chapter${id}`]

  if(!Chapter) return <p>No Template</p>

  return <Chapter.Intro {...props} />
}

export default withApp(connect(
  (state, props) => ({
    user: state.account.user,
    progress: state.account.progress,
    chapters: state.content.chapters,
    navigation: state.content.navigation,
  }),
  (dispatch) => ({
    accountActions: bindActionCreators(accountActions, dispatch)
  })
)(ChapterIntroView))



// WEBPACK FOOTER //
// ./src/components/views/chapters/ChapterIntroView.js